import JourneyDropoffEditor from 'reporting-enablement/components/reportEditors/JourneyDropoffEditor';
import { getJourneyIncludeDropoffsFromReport, isJourneyReport } from '../../../utils/salesAnalyticsHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const ShowDropoffControl = ({
  updateContext,
  report
}) => {
  return /*#__PURE__*/_jsx(JourneyDropoffEditor, {
    report: report,
    onChange: updatedReport => {
      updateContext({
        showDropoff: getJourneyIncludeDropoffsFromReport(updatedReport)
      }, report);
    }
  });
};
ShowDropoffControl.displayName = 'ShowDropoffControl';
ShowDropoffControl.isUsableForReport = ({
  report
}) => isJourneyReport(report);
export default ShowDropoffControl;